import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts").then(({ data }) => {
      setPosts(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-14" data-testid="blog-page">
      <span className="font-caveat text-3xl" style={{ color: "#6EC4E8" }}>notes from the nook</span>
      <h1 className="font-fredoka text-5xl sm:text-6xl" style={{ color: "#2D3055" }}>
        The Blog
      </h1>
      <p className="mt-4 max-w-2xl text-lg" style={{ color: "#4A4E6D" }}>
        Small essays, book updates, and gentle thoughts from behind the writing desk.
      </p>

      {loading && <p className="mt-10 font-nunito" style={{ color: "#7E82A1" }}>Gathering the notes…</p>}

      {!loading && posts.length === 0 && (
        <div className="mt-10 paper-card p-10 text-center" data-testid="blog-empty">
          <p className="font-fredoka text-2xl" style={{ color: "#2D3055" }}>The first note is almost ready…</p>
        </div>
      )}

      <div className="mt-10 space-y-8">
        {posts.map((p, idx) => (
          <Link
            key={p.id}
            to={`/blog/${p.slug}`}
            className="warm-card p-6 lg:p-8 grid md:grid-cols-3 gap-6 fade-up"
            style={{ animationDelay: `${idx * 80}ms` }}
            data-testid={`blog-card-${p.slug}`}
          >
            {p.cover_image_url && (
              <div className="md:col-span-1 rounded-2xl overflow-hidden aspect-[4/3]">
                <img src={p.cover_image_url} alt={p.title} className="w-full h-full object-cover" />
              </div>
            )}
            <div className={p.cover_image_url ? "md:col-span-2" : "md:col-span-3"}>
              <p className="font-caveat text-lg" style={{ color: "#FF6B9D" }}>
                {new Date(p.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
              </p>
              <h2 className="font-fredoka text-3xl mt-1" style={{ color: "#2D3055" }}>{p.title}</h2>
              <p className="mt-3" style={{ color: "#4A4E6D" }}>{p.excerpt}</p>
              <span className="mt-4 inline-block font-fredoka" style={{ color: "#FF6B9D" }}>Read the note →</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
